import { Component, OnInit } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { Paystub } from '@app/models/payroll/paystub.model';
import { CompanyAdditionalIncome } from '@app/models/payroll/company-additional-income.model';
import { AuthService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { AdditionalPayItem } from '@app/models/payroll/additional-pay-item.model';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-form-edit-bonus-pay-items',
    templateUrl: './edit-bonus-pay-items.template.html',
})
export class EditBonusPayItemsForm extends BaseForm implements OnInit {
    companyBonusIncomeTypes: CompanyAdditionalIncome[] = [];
    paystub?: Paystub;
    bonusTaxWarning = false;
    isShowingBonusTaxWarning = false;

    constructor(
        private auth: AuthService,
        private features: FeatureService
    ) {
        super();
    }

    getDisplayName(payItem: AdditionalPayItem): string | undefined {
        return this.companyBonusIncomeTypes.find((item) => item.name === payItem.name)?.displayName;
    }

    async ngOnInit(): Promise<void> {
        this.features
            .has(FeatureFlag.bonusTaxWarning)
            .then((bonusTaxWarning) => (this.bonusTaxWarning = bonusTaxWarning));

        const [companyAdditionalIncomes] = await CompanyAdditionalIncome.param('company', this.auth.company?.id)
            .where('active', true)
            .where('required', true)
            .get();

        this.companyBonusIncomeTypes = companyAdditionalIncomes.filter(({ name }) => name.includes('bonus'));
    }

    beforeShow(): void {
        this.createMissingPayItems();
        this.checkForOvertax();
    }

    /**
     * Show the bonus overtax warning if necessary.
     */
    checkForOvertax(): void {
        if (this.bonusTaxWarning) {
            this.isShowingBonusTaxWarning = Boolean(this.paystub?.isBonusMoreThanRegularPay);
        }
    }

    /**
     * Create pay items for the user to modify
     * If they don't save them, they are never persisted
     */
    private createMissingPayItems(): void {
        this.companyBonusIncomeTypes.forEach((companyAdditionalIncome: CompanyAdditionalIncome) => {
            if (!this.paystub) return;

            const payItemExists = this.paystub.bonusPayItems.some(({ name }) => name === companyAdditionalIncome.name);

            if (payItemExists) {
                return;
            }

            const payItem = this.createPayItem(companyAdditionalIncome, this.paystub);
            this.paystub.additionalPayItems = [...this.paystub.additionalPayItems, payItem];
        });
    }

    private createPayItem(companyAdditionalIncome: CompanyAdditionalIncome, paystub: Paystub): AdditionalPayItem {
        const payItem = new AdditionalPayItem();
        payItem.name = companyAdditionalIncome.name;
        payItem.paystubId = paystub.id;
        payItem.amount = 0;
        payItem.editable = true;
        payItem.userModified = true;

        return payItem;
    }
}
